module.exports = __webpack_public_path__ + "static/media/DsgProblems.574ead72.jpg";